import React, { useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import BasicTable from "../../components/UiComponent/customTable";
import {
  get_ekyc_lists,
  RegisterEKYC,
  UpdateEKYC,
} from "../../services/projectApi";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { GetUserInfo } from "../../utils/permissionChecker";
import { toast } from "react-toastify";
import { Modal, Row, Form, Col, Button, Spinner } from "react-bootstrap";
import { formatDate } from "../../utils/date_utils";
const EkycDevices = () => {
  const { t } = useTranslation();
  const user = GetUserInfo();
  const currentUser =
    user.employee.first_name + " " + user.employee.father_name;
  const branch = user?.employee?.branch_id;
  const queryClient = useQueryClient();
  const [showModal, setShowModal] = useState(false);
  const handleShowModal = () => {
    setShowModal(true);
    setFormError("");
  };
  const handleCloseModal = () => {
    setShowModal(false);
    setIsUpdateMode(false);
    setdevice_name("");
    setdeviceId("");
    setdevice_taype("");
    setserial_number("");
  };
  const [device_name, setdevice_name] = useState("");
  const [device_taype, setdevice_taype] = useState("");
  const [serial_number, setserial_number] = useState("");
  const [deviceId, setdeviceId] = useState("");
  const [formError, setFormError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const RegisterEKYCMutation = useMutation(async (newData) => {
    try {
      let result;
      if (isUpdateMode) {
        result = await UpdateEKYC(newData);
      } else {
        result = await RegisterEKYC(newData);
      }
      if (result) {
        queryClient.invalidateQueries("get_ekyc_devices");
        toast.success(result.message, {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        handleCloseModal();
      }
    } catch (error) {
      toast.error(error.message, {
        position: "top-right",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  });
  const getJobQuery = useQuery(["get_ekyc_devices"], () =>
    get_ekyc_lists(branch)
  );

  const deviceData = useMemo(() => {
    return getJobQuery.data || [];
  }, [getJobQuery.data]);
  if (getJobQuery.isLoading) {
    return <div>Loading...</div>;
  }
  if (getJobQuery.isError) {
    return <div>Error: {getJobQuery.error.message}</div>;
  }
  const Update = (event, data) => {
    event.preventDefault();
    setdevice_name(data.device_name);
    setdeviceId(data.id);
    setdevice_taype(data.device_taype);
    setserial_number(data.serial_number);
    setIsUpdateMode(true);
    handleShowModal();
  };
  const handleButtonSubmit = async (e) => {
    e.preventDefault();
    let deviceData;
    if (!device_name) {
      setFormError("Pease fill all fields are required ");
      return;
    }
    if (isUpdateMode) {
      deviceData = {
        id: deviceId,
        device_name,
        device_taype,
        serial_number,
        updated_by: currentUser,
      };
    } else {
      deviceData = {
        device_name,
        device_taype,
        serial_number,
        branch_id: branch,
        status: "ACTIVE",
        registered_user: currentUser,
      };
    }
    try {
      setIsSubmitting(true);
      await RegisterEKYCMutation.mutate(deviceData);
    } finally {
      setIsSubmitting(false);
    }
  };

  const deviceTableColumns = [
    {
      header: "name",
      accessorKey: "device_name",
    },
    {
      header: "taype",
      accessorKey: "device_taype",
    },
    {
      header: "serial_number",
      accessorKey: "serial_number",
    },
    {
      header: "status",
      accessorKey: "status",
    },
    {
      header: "Action",
      accessor: "id",
      cell: (row) => (
        <div className="d-flex justify-content align-items-center">
          <Button
            variant="btn btn-info btn-sm"
            onClick={(e) => Update(e, row.row.original)}
          >
            {t("update")}
          </Button>
        </div>
      ),
    },
  ];
  return (
    <>
      <BasicTable
        data={deviceData}
        columns={deviceTableColumns}
        title={`Device List`}
        actionButton={
          <Button
            variant="btn btn-info btn-sm"
            onClick={() => handleShowModal()}
          >
            {t("add_new_device")}
          </Button>
        }
      />
      <Modal
        show={showModal}
        onHide={handleCloseModal}
        centered={true}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title as="h5">
            {isUpdateMode ? "Update the device" : "Register new device"}{" "}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <Col lg="12">
                <Form.Group>
                  <Form.Label className="text-secondary">
                    Device Name
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter device name"
                    value={device_name}
                    onChange={(e) => setdevice_name(e.target.value)}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label className="text-secondary">
                    Device Type
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter device taype"
                    value={device_taype}
                    onChange={(e) => setdevice_taype(e.target.value)}
                  />
                  <p className="text-danger"> {formError}</p>
                </Form.Group>

                <Form.Group>
                  <Form.Label className="text-secondary">
                    Serial Number
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter serial number"
                    value={serial_number}
                    onChange={(e) => setserial_number(e.target.value)}
                  />
                  <p className="text-danger"> {formError}</p>
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
          {isSubmitting ? (
            <Button className="btn btn-info">
              <Spinner
                as="span"
                animation="grow"
                size="sm"
                role="status"
                aria-hidden="true"
              />
              <span className="visually-hidden">Sending...</span>
            </Button>
          ) : (
            <Button
              className="btn btn-info"
              onClick={(e) => handleButtonSubmit(e)}
            >
              {isUpdateMode ? "Update" : "Register"}
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default EkycDevices;
